module.exports = __webpack_public_path__ + "static/img/bestImg3.af3b478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/bestImg3.png
// module id = m7rl
// module chunks = 1